import { useRecoilState } from 'recoil';
import { IvyAuthorizationTokenAtom, IvyMyInfoAtom } from '../recoil/Authorization.recoil';
import { useEffect } from 'react';
import { fetchUsersMe } from '../repository/LoginRepository';
import _ from 'lodash';
import { AuthUtils } from '../utils/AuthUtils';

export const IvyUserInfoService = () => {
  const [token, setToken] = useRecoilState(IvyAuthorizationTokenAtom);
  const [myInfo, setMyInfo] = useRecoilState(IvyMyInfoAtom);

  useEffect(() => {
    if (_.isEmpty(token)) {
      const tokenFromCookie = AuthUtils.getCookie('token');
      if (_.isEmpty(tokenFromCookie)) {
        AuthUtils.needLogin();
      } else {
        setToken(tokenFromCookie);
        fetchUsersMe(tokenFromCookie)
          .then((res) => {
            if (res.status === 'NORMAL') {
              setMyInfo(res);
            } else {
              console.log('에러발생');
            }
          })
          .catch((error) => console.error(error));
      }
    }
  }, []);
};
